import React from 'react';
import PropTypes from 'prop-types';
import InputLabel from '@material-ui/core/InputLabel/InputLabel';
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import FormControl from '@material-ui/core/FormControl/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Select from '@material-ui/core/Select/Select';

const getValue = (item, field) => item[field] !== undefined ? item[field] : item;

const YMMSelect = (props) => (
  <FormControl
    className={props.classes.select}
  >
    <InputLabel>{props.label}</InputLabel>
    <Select
      value={props.value}
      MenuProps={{
        PaperProps: {
          style: {
            transform: 'translate3d(0, 0, 0)',
          },
        },
      }}
      disabled={props.error || props.loading || props.data.length === 0}
      onChange={(evt) => props.handleSelection({ field: props.field, value: evt.target.value })}
    >
      {
        props.data.map(item => (<MenuItem key={getValue(item, props.field)} value={getValue(item, props.field)}>{item.toString()}</MenuItem>))
      }
    </Select>
    {
      props.loading ? <FormHelperText>{props.loading}</FormHelperText> : null
    }
    {
      props.error ? <FormHelperText error>{props.error}</FormHelperText> : null
    }
  </FormControl>
);

YMMSelect.propTypes = {
  value: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.any),
  field: PropTypes.string,
  label: PropTypes.string,
  classes: PropTypes.object,
  handleSelection: PropTypes.func,
  loading: PropTypes.string,
  error: PropTypes.string,
};

YMMSelect.defaultProps = {
  value: '',
  data: [],
};

export default YMMSelect;



// WEBPACK FOOTER //
// ./src/settings/components/YMMSelect.jsx